const CLEARANCE_GAP_PX = 16;

const STICKY_FOOTER_SELECTOR = '[data-test-id="StickyFooter"]';

export const scrollClearOfStickyFooter = (el: HTMLElement) => {
  const footer = globalThis.document.querySelector(STICKY_FOOTER_SELECTOR);
  const clearAbove = footer ? footer.getBoundingClientRect().top : globalThis.innerHeight;
  const overlap = el.getBoundingClientRect().bottom + CLEARANCE_GAP_PX - clearAbove;
  if (overlap <= 0) return;

  const behavior = globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  globalThis.scrollBy({ top: overlap, behavior });
};
